import queryString from 'query-string';
import { get } from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import { API, fetchWFS } from '../../api';

const getMapSettings = ({ mapSettings }) => mapSettings.MAIN_MAP;
const getServerConfig = ({ serverConfig }) => serverConfig;
const PROPS = [
  'add_combo',
  'priority',
  'parcel_id',
  'general_zoning',
  'zoning',
  'lst_sle_dt',
  'rb_flr_ar_num',
  'cib_flr_ar_num',
  'rb_nbed',
  'bath_num',
  'rb_yr_blt',
  'taxStatus',
  'occStatus',
  'own_prop_ct',
  'esttcv',
  'open_prmts',
  'changeability',
  'rental',
  'owner_name',
  'pre',
  'violations',
  'open_prmts',
  'open_vio',
  'oth_prop_vios',
  'incdnt_cnt',
  'yx',
].join(',');

export function* fetchReportData(action) {
  const { center } = yield select(getMapSettings);
  yield put({ type: 'START_REPORT_LOADING' });

  const config = get(action, 'payload.config', {});

  const { lat, lng } = config.lngLat || center;
  let results;
  const serverConfig = yield select(getServerConfig);
  if (config.parcelId) {
    const query = {
      props: PROPS,
    };

    const path = `/parcel/${serverConfig.namespace}/${
      config.parcelId
    }?${queryString.stringify(query)}`;

    results = yield call(API, 'get', 'api', path);
    results.parcels = get(results, 'parcels', []);
  } else {
    const query = {
      latlng: `${lat},${lng}`,
      props: PROPS,
    };

    const path = `/parcel/${
      serverConfig.namespace
    }/coord?${queryString.stringify(query)}`;

    results = yield call(API, 'get', 'api', path);
  }
  yield put({
    type: 'ADD_PARCELS',
    payload: {
      parcels: results.parcels,
    },
  });

  const parcelId = get(results, 'parcels[0].parcel_id');

  if (!parcelId) {
    yield put({ type: 'CLOSE_MODAL' });
    return;
  }

  const water = yield call(fetchWFS, {
    parcelId,
    request: 'GetFeature',
    typename: 'water_graph',
  });

  yield put({
    type: 'STORE_WATER_DATA',
    payload: {
      id: parcelId,
      data: water.features.map((feature) => ({
        id: feature.id,
        gallons: feature.properties.bl_usage,
        quarter: feature.properties.qrtr,
        year: feature.properties.year,
      })),
    },
  });

  yield put({
    type: 'SELECT_PARCEL',
    payload: {
      id: parcelId,
    },
  });
  yield put({ type: 'STOP_REPORT_LOADING' });

  yield put({
    type: 'TRACK',
    payload: {
      name: 'Report opened',
      type: 'Code Enforcement Parcel Report',
      parcelId,
    },
  });
}
